import './style.css'
import { Gallery } from '../Gallery'

const img_man = [
    'https://jullnik2026.ru/img/m-1.jpeg',
    'https://jullnik2026.ru/img/m-2.jpeg',
    'https://jullnik2026.ru/img/m-3.jpeg',
    'https://jullnik2026.ru/img/m-4.jpeg',
    'https://jullnik2026.ru/img/m-5.jpeg',
    'https://jullnik2026.ru/img/m-6.jpeg',
]

const img_woman = [
    'https://jullnik2026.ru/img/w-1.jpeg',
    'https://jullnik2026.ru/img/w-2.jpeg',
    'https://jullnik2026.ru/img/w-3.jpeg',
    'https://jullnik2026.ru/img/w-4.jpeg',
    'https://jullnik2026.ru/img/w-5.jpeg',
    'https://jullnik2026.ru/img/w-6.jpeg',
]

export const Dresscode = () => {
    return (
        <div className='Dresscode'>
            <div className='Container__second'>
                <div className='Title'>
                    Дресс-код
                </div>
                <div className='Dresscode__description'>Мы очень старались сделать праздник красивым и будем рады, если в своих нарядах вы поддержите цветовую гамму нашей свадьбы</div>
                <div className='Dresscode__container'>
                    <img src="https://jullnik2026.ru/img/dresscode.jpg" className='Dresscode__img' alt='dresscode' />
                </div>
                <div className='Dresscode__subtitle'>Девушки</div>
                <div className='Dresscode__text'>Вечерние платья, костюмы, юбки, блузки. Приветствуются аксессуары в палитре торжества.</div>
            </div>
            <Gallery data={img_woman} />
            <div className='Container__second'>
                <div className='Dresscode__subtitle'>Мужчины</div>
                <div className='Dresscode__text'>Рубашка или футболка, брюки и пиджак.</div>
            </div>
            <Gallery data={img_man} />
        </div>
    )
}